import { connect } from 'react-redux'
import {
  selectShowDemoMailboxBar,
  selectDoesCurrentMailboxHaveState,
} from 'selectors/mailboxes'
import {
  selectShowExpiredBilling,
  selectShowPendingCancellation,
  selectCancelsAt,
  selectShowCreditCardExpireSoon,
  selectShowCreditCardExpired,
  selectPrimaryCreditCard,
  selectShowLastBillingFailed,
  selectShowTrialMessage,
  selectDaysLeftBeforeExpiring,
} from 'ducks/billing/selectors'
import {
  selectCurrentUserIsAdmin,
  selectCurrentUserIsOwner,
} from 'ducks/currentUser/selectors'
import { selectGitHubNeedsReinstall } from 'ducks/integrations/github'
import { selectIsWidgetFromUrlDisconnected } from 'ducks/widgets/selectors/widgets'
import { selectShowTwitterDeprecation } from 'ducks/integrations/twitter/selectors'
import AppNoticesView from './view'

const select = state => ({
  showDemoMailboxBar: selectShowDemoMailboxBar(state),
  showExpiredBilling: selectShowExpiredBilling(state),
  showGitHubReauth: selectGitHubNeedsReinstall(state),
  showPendingCancellation: selectShowPendingCancellation(state),
  showCreditCardExpireSoon: selectShowCreditCardExpireSoon(state),
  showCreditCardExpired: selectShowCreditCardExpired(state),
  showLastBillingFailed: selectShowLastBillingFailed(state),
  creditCard: selectPrimaryCreditCard(state),
  cancelsAt: selectCancelsAt(state),
  showTrialMessage: selectShowTrialMessage(state, 'inbox'),
  trialDaysLeft: selectDaysLeftBeforeExpiring(state, 'inbox'),
  isAdmin: selectCurrentUserIsAdmin(state),
  isOwner: selectCurrentUserIsOwner(state),
  isCurrentMailboxConfirmedOrUnconfirmed: selectDoesCurrentMailboxHaveState(
    state,
    ['unconfirmed'],
    null,
    ['FORWARDING']
  ),
  isCurrentMailboxDisconnected: selectDoesCurrentMailboxHaveState(state, [
    'disconnected',
  ]),
  isCurrentMailboxConfirmedOrUnconfirmedLegacy: selectDoesCurrentMailboxHaveState(
    state,
    ['unconfirmed'],
    null,
    ['LEGACY']
  ),
  isWidgetFromUrlDisconnected: selectIsWidgetFromUrlDisconnected(state),
  showTwitterDeprecation: selectShowTwitterDeprecation(state),
})

export default connect(select)(AppNoticesView)
